import { render, staticRenderFns } from "./PointsSpent.vue?vue&type=template&id=44c69e20&"
import script from "./PointsSpent.vue?vue&type=script&lang=js&"
export * from "./PointsSpent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports